import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QPointIconModule } from '@qpoint/icons';

import { QPointContextbarService } from '../contextbar/contextbar.service/contextbar.service';
import { QPointExportCurrentGridComponent } from '../contextbar/export-current-grid/export-current-grid.component';
import { GridConnectService } from '../grid/grid-connect.service';
import { QPointSidebarService } from '../sidebar/sidebar.service/sidebar.service';
import { QPointToolbarButtonComponent } from './toolbar-button/toolbar-button.component';
import { QPointToolbarDividerComponent } from './toolbar-divider/toolbar-divider.component';

export interface IRoutingBreadcrumb {
  name: string;
  translationParams?: any;
  route?: string;
  localizeText?: boolean;
  disabled?: boolean;
}

@Component({
    selector: 'qpoint-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        QPointIconModule,
        TranslateModule,
        CommonModule,
        forwardRef(() => QPointExportCurrentGridComponent),
        QPointToolbarDividerComponent,
        QPointToolbarButtonComponent,
        NgbTooltip
    ]
})
export class QPointToolbarComponent {
  @Input()
  public title: string | string[] | IRoutingBreadcrumb[];

  public get titleAsString() {
    return <string>this.title;
  }

  @Input()
  public showContextbarButton = false;

  @Input()
  public contextbarFilterActive = false;

  @Input()
  public showAbortButton = false;

  @Input()
  public abortButtonTooltip;

  @Input()
  public showToolbarDividerBeforeAbortButton = true;

  @Output()
  public abortButtonClicked = new EventEmitter<void>();

  public isMenuCollapsed: boolean;

  public get isContextbarCollapsed() {
    return this.contextbarService.isContextbarCollapsed;
  }

  constructor(
    private router: Router,
    public sidebarService: QPointSidebarService,
    public contextbarService: QPointContextbarService,
    public gridConnectService: GridConnectService) {
    this.contextbarService.collapseContextbar();
  }

  public toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  public toogleContextbar() {
    this.contextbarService.toggleContextbar();
  }

  public navigateTo(routingBreadcrumb: IRoutingBreadcrumb) {
    if (routingBreadcrumb.route && (routingBreadcrumb.disabled == null || routingBreadcrumb.disabled == undefined || !routingBreadcrumb.disabled)) {
      this.router.navigateByUrl(routingBreadcrumb.route);
    }
  }

  public isTitleAString(title): title is string {
    return typeof this.title === 'string';
  }

  public isTitleAStringArray(title): title is string[] {
    return this.title instanceof Array && this.title && typeof this.title[0] === 'string';
  }

  public isTitleAObjectArray(title): title is IRoutingBreadcrumb[] {
    return this.title instanceof Array && this.title && this.title[0] instanceof Object;
  }

  public abort() {
    this.abortButtonClicked.emit();
  }
}
